

import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const TextosTerminos = ({ terminos, lang }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <section className="u-clearfix u-image u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-section-1" id="sec-5458" data-image-width="1500" data-image-height="1000">
                <h1 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-white u-title u-text-1">{t("Términos").toUpperCase()}</h1>
            </section>
            <section className="u-clearfix u-section-3" id="block-10">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-sheet-1">
                    {ReactHtmlParser(terminos.ladesc)}
                </div>
            </section>
        </>
    );
}

export default TextosTerminos;
